export const MANAGEMENT_USER_QUERY_KEY = 'user';

export function buildUsersManagementReturnQuery(userId: string): {
  user: string;
} {
  return { user: userId };
}
